export default {
  company: 'Unternehmen',
  titleInternal: 'Anzeigetitel (intern)',
  projectNumber: 'Auftragsnummer',
  creationDate: 'Erstelldatum',
  serviceType: 'Leistungsart',
  consultant: 'Berater',
  comment: 'Kommentar'
};
